"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PieChart24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C17.5228 2 22 6.47715 22 12C22 14.59 21.0154 16.95 19.4001 18.7261L12 12V2ZM14 4.253V11.115L19.077 15.731L19.1461 15.6018C19.6551 14.5939 19.9485 13.4791 19.9938 12.3178L20 12C20 8.332 17.5314 5.24056 14.165 4.2964L14 4.253ZM3 12C3 7.71681 5.99202 4.13246 10 3.223V5.28986C7.10851 6.15041 5 8.82896 5 12C5 15.866 8.13401 19 12 19C13.2236 19 14.3738 18.686 15.3746 18.1343L17.0691 19.4377C15.6254 20.4235 13.88 21 12 21C7.02944 21 3 16.9705 3 12Z", fill: "#383F49" }));
}
function PieChart24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PieChart24Svg, Object.assign({}, svgProps)));
}
exports.default = PieChart24;
//# sourceMappingURL=PieChart24.js.map